import React from 'react';
import P from 'prop-types';
import classNames from 'classnames';
// eslint-disable-next-line lodash/import-scope
import property from 'lodash/property';
import { Impression } from '@nerdwallet/analytics/react/impression';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import BackgroundColor from '../background-color/background-color';
import UniversalContainer from '../universal-container/universal-container';
import editingConfig from './horizontal-banner-editing-config';
import BannerHorizontaContent from './horizontal-banner-content';
import './horizontal-banner.less';
import { useHorizontalBanner } from './use-horizontal-banner';

const HorizontalBanner = ({
  container,
  title,
  subtitle,
  actionButton,
  authButton,
  disableDefaultProps,
  includeSignUpButtons,
  includeContentWidthLimitation,
  includeParentWithLimitation,
  isSignedIn,
  rootBgOptions,
}) => {
  const { titleProps, subtitleProps, containerProps, actionButtonProps } =
    useHorizontalBanner({
      title,
      subtitle,
      container,
      actionButton,
      disableDefaultProps,
    });

  return includeSignUpButtons && isSignedIn ? null : (
    <BackgroundColor bgOptions={rootBgOptions}>
      {(rootBackgroundColor) => (
        <Impression
          eventType="element_impression"
          entityName="horizontal_banner"
          className={classNames('horizontal-banner__wrapper', {
            '_not-wide': includeParentWithLimitation,
          })}
          style={{
            backgroundColor: rootBackgroundColor,
          }}
        >
          <UniversalContainer {...containerProps}>
            <BannerHorizontaContent
              actionButtonProps={actionButtonProps}
              authButton={authButton}
              includeContentWidthLimitation={includeContentWidthLimitation}
              includeSignUpButtons={includeSignUpButtons}
              isSignedIn={isSignedIn}
              subtitleProps={subtitleProps}
              titleProps={titleProps}
            />
          </UniversalContainer>
        </Impression>
      )}
    </BackgroundColor>
  );
};

HorizontalBanner.displayName = 'Horizontal Banner';

HorizontalBanner.propTypes = {
  ...BackgroundColor.propTypes,
  rootBgOptions: P.shape({ ...BackgroundColor.bgOptions }),
  disableDefaultProps: P.bool,
  children: P.node,
};

HorizontalBanner.defaultProps = {
  ...BackgroundColor.defaultProps,
  includeSignUpButtons: false,
  includeContentWidthLimitation: false,
  includeParentWithLimitation: false,
  rootBgOptions: BackgroundColor.defaultProps.bgOptions,
  disableDefaultProps: false,
  children: null,
};

HorizontalBanner.getEditingConfig = editingConfig;

export default connect(
  createStructuredSelector({
    size: property('mediaQuery'),
    isSignedIn: property('identity.isSignedIn'),
  })
)(HorizontalBanner);
